export interface Location {
  lid: string;
  lidl: string;
}

export const topCities: Location[] = [
  { lid: '1-48', lidl: 'Stockholm' },
  { lid: '14-22', lidl: 'Göteborg' },
  { lid: '12-36', lidl: 'Malmö' },
  { lid: '3-11', lidl: 'Uppsala' },
  { lid: '19-13', lidl: 'Västerås' },
  { lid: '5-8', lidl: 'Linköping' },
  { lid: '18-17', lidl: 'Örebro' },
];

export const locations: Location[] = [
  { lid: '21-2', lidl: 'Alfta' },
  { lid: '14-2', lidl: 'Alingsås' },
  { lid: '22-2', lidl: 'Alnö' },
  { lid: '3-2', lidl: 'Alunda' },
  { lid: '7-2', lidl: 'Alvesta' },
  { lid: '12-2', lidl: 'Anderslöv' },
  { lid: '6-2', lidl: 'Anderstorp' },
  { lid: '6-3', lidl: 'Aneby' },
  { lid: '14-3', lidl: 'Angered' },
  { lid: '8-2', lidl: 'Ankarsrum' },
  { lid: '19-2', lidl: 'Arboga' },
  { lid: '21-3', lidl: 'Arbrå' },
  { lid: '25-2', lidl: 'Arjeplog' },
  { lid: '1-2', lidl: 'Arlanda' },
  { lid: '12-3', lidl: 'Arlöv' },
  { lid: '25-3', lidl: 'Arvidsjaur' },
  { lid: '17-2', lidl: 'Arvika' },
  { lid: '10-2', lidl: 'Asarum' },
  { lid: '18-2', lidl: 'Askersund' },
  { lid: '14-4', lidl: 'Askim' },
  { lid: '20-2', lidl: 'Avesta' },
  { lid: '23-2', lidl: 'Backe' },
  { lid: '1-3', lidl: 'Bagarmossen' },
  { lid: '1-4', lidl: 'Bandhagen' },
  { lid: '6-4', lidl: 'Bankeryd' },
  { lid: '14-5', lidl: 'Bengtsfors' },
  { lid: '21-4', lidl: 'Bergby' },
  { lid: '21-5', lidl: 'Bergsjö' },
  { lid: '21-6', lidl: 'Bergvik' },
  { lid: '13-2', lidl: 'Billdal' },
  { lid: '24-2', lidl: 'Bjurholm' },
  { lid: '12-4', lidl: 'Bjuv' },
  { lid: '12-5', lidl: 'Bjärnum' },
  { lid: '12-6', lidl: 'Bjärred' },
  { lid: '22-3', lidl: 'Bjästa' },
  { lid: '8-3', lidl: 'Blomstermåla' },
  { lid: '6-5', lidl: 'Bodafors' },
  { lid: '25-4', lidl: 'Boden' },
  { lid: '14-6', lidl: 'Bohus' },
  { lid: '24-3', lidl: 'Boliden' },
  { lid: '14-7', lidl: 'Bollebygd' },
  { lid: '21-7', lidl: 'Bollnäs' },
  { lid: '5-2', lidl: 'Borensberg' },
  { lid: '8-4', lidl: 'Borgholm' },
  { lid: '20-3', lidl: 'Borlänge' },
  { lid: '12-7', lidl: 'Borrby' },
  { lid: '14-8', lidl: 'Borås' },
  { lid: '1-5', lidl: 'Botkyrka' },
  { lid: '5-3', lidl: 'Boxholm' },
  { lid: '1-6', lidl: 'Brandbergen' },
  { lid: '22-4', lidl: 'Bredbyn' },
  { lid: '1-7', lidl: 'Bro' },
  { lid: '12-8', lidl: 'Broby' },
  { lid: '1-8', lidl: 'Bromma' },
  { lid: '12-9', lidl: 'Bromölla' },
  { lid: '23-3', lidl: 'Brunflo' },
  { lid: '23-4', lidl: 'Bräcke' },
  { lid: '14-9', lidl: 'Brålanda' },
  { lid: '12-10', lidl: 'Brösarp' },
  { lid: '13-3', lidl: 'Bua' },
  { lid: '12-11', lidl: 'Bunkeflostrand' },
  { lid: '24-4', lidl: 'Bureå' },
  { lid: '24-5', lidl: 'Burträsk' },
  { lid: '24-6', lidl: 'Byske' },
  { lid: '3-3', lidl: 'Bålsta' },
  { lid: '12-12', lidl: 'Båstad' },
  { lid: '17-3', lidl: 'Charlottenberg' },
  { lid: '12-13', lidl: 'Dalby' },
  { lid: '14-10', lidl: 'Dalsjöfors' },
  { lid: '1-9', lidl: 'Danderyd' },
  { lid: '12-14', lidl: 'Degeberga' },
  { lid: '18-3', lidl: 'Degerfors' },
  { lid: '21-8', lidl: 'Delsbo' },
  { lid: '1-10', lidl: 'Djursholm' },
  { lid: '20-4', lidl: 'Djurås' },
  { lid: '22-5', lidl: 'Domsjö' },
  { lid: '24-7', lidl: 'Dorotea' },
  { lid: '14-11', lidl: 'Ed' },
  { lid: '21-9', lidl: 'Edsbyn' },
  { lid: '1-11', lidl: 'Ekerö' },
  { lid: '17-4', lidl: 'Ekshärad' },
  { lid: '6-6', lidl: 'Eksjö' },
  { lid: '14-12', lidl: 'Ellös' },
  { lid: '8-5', lidl: 'Emmaboda' },
  { lid: '1-12', lidl: 'Enebyberg' },
  { lid: '3-4', lidl: 'Enköping' },
  { lid: '1-13', lidl: 'Enskede' },
  { lid: '1-14', lidl: 'Enskededalen' },
  { lid: '4-2', lidl: 'Eskilstuna' },
  { lid: '12-15', lidl: 'Eslöv' },
  { lid: '19-3', lidl: 'Fagersta' },
  { lid: '13-4', lidl: 'Falkenberg' },
  { lid: '14-13', lidl: 'Falköping' },
  { lid: '20-5', lidl: 'Falun' },
  { lid: '1-15', lidl: 'Farsta' },
  { lid: '17-5', lidl: 'Filipstad' },
  { lid: '5-4', lidl: 'Finspång' },
  { lid: '18-4', lidl: 'Fjugesta' },
  { lid: '14-14', lidl: 'Fjällbacka' },
  { lid: '13-5', lidl: 'Fjärås' },
  { lid: '4-3', lidl: 'Flen' },
  { lid: '14-15', lidl: 'Floda' },
  { lid: '17-6', lidl: 'Forshaga' },
  { lid: '14-16', lidl: 'Fristad' },
  { lid: '22-6', lidl: 'Fränsta' },
  { lid: '23-5', lidl: 'Frösön' },
  { lid: '18-5', lidl: 'Frövi' },
  { lid: '23-6', lidl: 'Funäsdalen' },
  { lid: '14-17', lidl: 'Färgelanda' },
  { lid: '21-10', lidl: 'Färila' },
  { lid: '8-6', lidl: 'Färjestaden' },
  { lid: '12-16', lidl: 'Förslöv' },
  { lid: '8-7', lidl: 'Gamleby' },
  { lid: '25-5', lidl: 'Gammelstad' },
  { lid: '13-6', lidl: 'Getinge' },
  { lid: '3-5', lidl: 'Gimo' },
  { lid: '6-7', lidl: 'Gislaved' },
  { lid: '4-4', lidl: 'Gnesta' },
  { lid: '6-8', lidl: 'Gnosjö' },
  { lid: '14-18', lidl: 'Grebbestad' },
  { lid: '17-7', lidl: 'Grums' },
  { lid: '20-6', lidl: 'Grycksbo' },
  { lid: '20-7', lidl: 'Grängesberg' },
  { lid: '14-19', lidl: 'Grästorp' },
  { lid: '14-20', lidl: 'Gråbo' },
  { lid: '14-21', lidl: 'Gullspång' },
  { lid: '1-16', lidl: 'Gustavsberg' },
  { lid: '23-7', lidl: 'Gäddede' },
  { lid: '25-6', lidl: 'Gällivare' },
  { lid: '21-11', lidl: 'Gävle' },
  { lid: '14-23', lidl: 'Götene' },
  { lid: '6-9', lidl: 'Habo' },
  { lid: '17-8', lidl: 'Hagfors' },
  { lid: '18-6', lidl: 'Hallsberg' },
  { lid: '19-4', lidl: 'Hallstahammar' },
  { lid: '1-17', lidl: 'Hallstavik' },
  { lid: '13-7', lidl: 'Halmstad' },
  { lid: '23-8', lidl: 'Hammarstrand' },
  { lid: '17-9', lidl: 'Hammarö' },
  { lid: '23-9', lidl: 'Hammerdal' },
  { lid: '1-18', lidl: 'Haninge' },
  { lid: '25-7', lidl: 'Haparanda' },
  { lid: '21-12', lidl: 'Harmånger' },
  { lid: '3-6', lidl: 'Heby' },
  { lid: '23-10', lidl: 'Hede' },
  { lid: '20-8', lidl: 'Hedemora' },
  { lid: '21-13', lidl: 'Hedesunda' },
  { lid: '12-17', lidl: 'Helsingborg' },
  { lid: '9-2', lidl: 'Hemse' },
  { lid: '14-24', lidl: 'Henån' },
  { lid: '14-25', lidl: 'Herrljunga' },
  { lid: '14-26', lidl: 'Hisings Backa' },
  { lid: '14-27', lidl: 'Hisings Kärra' },
  { lid: '14-28', lidl: 'Hjo' },
  { lid: '12-18', lidl: 'Hjärup' },
  { lid: '21-14', lidl: 'Hofors' },
  { lid: '24-8', lidl: 'Holmsund' },
  { lid: '25-7', lidl: 'Hortlax' },
  { lid: '23-11', lidl: 'Hoting' },
  { lid: '14-29', lidl: 'Hova' },
  { lid: '14-30', lidl: 'Hovås' },
  { lid: '1-19', lidl: 'Huddinge' },
  { lid: '21-15', lidl: 'Hudiksvall' },
  { lid: '8-8', lidl: 'Hultsfred' },
  { lid: '14-31', lidl: 'Hunnebostrand' },
  { lid: '6-10', lidl: 'Huskvarna' },
  { lid: '22-7', lidl: 'Husum' },
  { lid: '12-19', lidl: 'Hyllinge' },
  { lid: '13-8', lidl: 'Hyltebruk' },
  { lid: '1-20', lidl: 'Hägersten' },
  { lid: '18-7', lidl: 'Hällefors' },
  { lid: '22-8', lidl: 'Härnösand' },
  { lid: '1-21', lidl: 'Hässelby' },
  { lid: '12-20', lidl: 'Hässleholm' },
  { lid: '12-21', lidl: 'Höganäs' },
  { lid: '14-32', lidl: 'Högsbo' },
  { lid: '8-9', lidl: 'Högsby' },
  { lid: '12-22', lidl: 'Höllviken' },
  { lid: '12-23', lidl: 'Hörby' },
  { lid: '24-9', lidl: 'Hörnefors' },
  { lid: '12-24', lidl: 'Höör' },
  { lid: '21-16', lidl: 'Iggesund' },
  { lid: '20-9', lidl: 'Insjön' },
  { lid: '1-22', lidl: 'Johanneshov' },
  { lid: '25-9', lidl: 'Jokkmokk' },
  { lid: '10-3', lidl: 'Jämjö' },
  { lid: '1-23', lidl: 'Järfälla' },
  { lid: '1-24', lidl: 'Järna' },
  { lid: '23-12', lidl: 'Järpen' },
  { lid: '21-17', lidl: 'Järvsö' },
  { lid: '6-11', lidl: 'Jönköping' },
  { lid: '24-10', lidl: 'Jörn' },
  { lid: '25-10', lidl: 'Kalix' },
  { lid: '10-4', lidl: 'Kallinge' },
  { lid: '8-10', lidl: 'Kalmar' },
  { lid: '14-33', lidl: 'Karlsborg' },
  { lid: '10-5', lidl: 'Karlshamn' },
  { lid: '18-8', lidl: 'Karlskoga' },
  { lid: '10-6', lidl: 'Karlskrona' },
  { lid: '17-10', lidl: 'Karlstad' },
  { lid: '4-5', lidl: 'Katrineholm' },
  { lid: '17-11', lidl: 'Kil' },
  { lid: '21-18', lidl: 'Kilafors' },
  { lid: '14-34', lidl: 'Kinna' },
  { lid: '25-11', lidl: 'Kiruna' },
  { lid: '5-5', lidl: 'Kisa' },
  { lid: '1-25', lidl: 'Kista' },
  { lid: '9-3', lidl: 'Klintehamn' },
  { lid: '12-25', lidl: 'Klippan' },
  { lid: '12-26', lidl: 'Knislinge' },
  { lid: '3-7', lidl: 'Knivsta' },
  { lid: '5-6', lidl: 'Kolmården' },
  { lid: '19-5', lidl: 'Kolsva' },
  { lid: '18-9', lidl: 'Kopparberg' },
  { lid: '22-9', lidl: 'Kramfors' },
  { lid: '12-27', lidl: 'Kristianstad' },
  { lid: '17-12', lidl: 'Kristinehamn' },
  { lid: '23-13', lidl: 'Krokom' },
  { lid: '18-10', lidl: 'Kumla' },
  { lid: '1-26', lidl: 'Kungens Kurva' },
  { lid: '13-9', lidl: 'Kungsbacka' },
  { lid: '14-35', lidl: 'Kungshamn' },
  { lid: '1-27', lidl: 'Kungsängen' },
  { lid: '19-6', lidl: 'Kungsör' },
  { lid: '14-36', lidl: 'Kungälv' },
  { lid: '22-10', lidl: 'Kvissleby' },
  { lid: '1-28', lidl: 'Kärrtorp' },
  { lid: '12-28', lidl: 'Kävlinge' },
  { lid: '24-11', lidl: 'Kåge' },
  { lid: '14-37', lidl: 'Kållekärr' },
  { lid: '14-38', lidl: 'Kållered' },
  { lid: '19-7', lidl: 'Köping' },
  { lid: '13-10', lidl: 'Laholm' },
  { lid: '7-3', lidl: 'Lammhult' },
  { lid: '6-12', lidl: 'Landsbro' },
  { lid: '12-29', lidl: 'Landskrona' },
  { lid: '14-39', lidl: 'Landvetter' },
  { lid: '18-11', lidl: 'Laxå' },
  { lid: '20-10', lidl: 'Leksand' },
  { lid: '7-4', lidl: 'Lenhovda' },
  { lid: '14-40', lidl: 'Lerum' },
  { lid: '7-5', lidl: 'Lessebo' },
  { lid: '22-11', lidl: 'Liden' },
  { lid: '1-29', lidl: 'Lidingö' },
  { lid: '14-41', lidl: 'Lidköping' },
  { lid: '17-13', lidl: 'Likenäs' },
  { lid: '14-42', lidl: 'Lilla Edet' },
  { lid: '12-30', lidl: 'Limhamn' },
  { lid: '18-12', lidl: 'Lindesberg' },
  { lid: '14-43', lidl: 'Lindome' },
  { lid: '5-7', lidl: 'Linghem' },
  { lid: '23-14', lidl: 'Lit' },
  { lid: '7-6', lidl: 'Ljungby' },
  { lid: '8-11', lidl: 'Ljungbyholm' },
  { lid: '5-9', lidl: 'Ljungsbro' },
  { lid: '14-44', lidl: 'Ljungskile' },
  { lid: '21-19', lidl: 'Ljusdal' },
  { lid: '12-31', lidl: 'Lomma' },
  { lid: '20-11', lidl: 'Ludvika' },
  { lid: '25-12', lidl: 'Luleå' },
  { lid: '12-32', lidl: 'Lund' },
  { lid: '10-7', lidl: 'Lyckeby' },
  { lid: '24-12', lidl: 'Lycksele' },
  { lid: '14-45', lidl: 'Lysekil' },
  { lid: '20-12', lidl: 'Långshyttan' },
  { lid: '12-33', lidl: 'Löberöd' },
  { lid: '12-34', lidl: 'Löddeköpinge' },
  { lid: '12-35', lidl: 'Lönsboda' },
  { lid: '24-13', lidl: 'Lövånger' },
  { lid: '4-6', lidl: 'Malmköping' },
  { lid: '20-13', lidl: 'Malung' },
  { lid: '24-14', lidl: 'Malå' },
  { lid: '5-10', lidl: 'Mantorp' },
  { lid: '4-7', lidl: 'Mariefred' },
  { lid: '14-46', lidl: 'Mariestad' },
  { lid: '7-7', lidl: 'Markaryd' },
  { lid: '22-12', lidl: 'Matfors' },
  { lid: '13-11', lidl: 'Mellbystrand' },
  { lid: '14-47', lidl: 'Mellerud' },
  { lid: '5-11', lidl: 'Mjölby' },
  { lid: '7-8', lidl: 'Moheda' },
  { lid: '17-14', lidl: 'Molkom' },
  { lid: '20-14', lidl: 'Mora' },
  { lid: '5-12', lidl: 'Motala' },
  { lid: '6-13', lidl: 'Mullsjö' },
  { lid: '12-37', lidl: 'Munka Ljungby' },
  { lid: '14-48', lidl: 'Munkedal' },
  { lid: '17-15', lidl: 'Munkfors' },
  { lid: '14-49', lidl: 'Myggenäs' },
  { lid: '1-30', lidl: 'Märsta' },
  { lid: '14-50', lidl: 'Mölndal' },
  { lid: '14-51', lidl: 'Mölnlycke' },
  { lid: '8-12', lidl: 'Mönsterås' },
  { lid: '8-13', lidl: 'Mörbylånga' },
  { lid: '8-14', lidl: 'Mörlunda' },
  { lid: '1-31', lidl: 'Nacka' },
  { lid: '18-13', lidl: 'Nora' },
  { lid: '19-8', lidl: 'Norberg' },
  { lid: '24-15', lidl: 'Nordmaling' },
  { lid: '6-14', lidl: 'Norrahammar' },
  { lid: '5-13', lidl: 'Norrköping' },
  { lid: '1-32', lidl: 'Norrtälje' },
  { lid: '1-33', lidl: 'Norsborg' },
  { lid: '24-16', lidl: 'Norsjö' },
  { lid: '14-52', lidl: 'Nossebro' },
  { lid: '8-15', lidl: 'Nybro' },
  { lid: '1-34', lidl: 'Nykvarn' },
  { lid: '4-8', lidl: 'Nyköping' },
  { lid: '22-13', lidl: 'Nyland' },
  { lid: '1-35', lidl: 'Nynäshamn' },
  { lid: '6-15', lidl: 'Nässjö' },
  { lid: '14-53', lidl: 'Nödinge' },
  { lid: '21-20', lidl: 'Ockelbo' },
  { lid: '18-14', lidl: 'Odensbacken' },
  { lid: '23-15', lidl: 'Offerdal' },
  { lid: '10-8', lidl: 'Olofström' },
  { lid: '13-12', lidl: 'Onsala' },
  { lid: '20-15', lidl: 'Orsa' },
  { lid: '12-38', lidl: 'Osby' },
  { lid: '8-16', lidl: 'Oskarshamn' },
  { lid: '13-13', lidl: 'Oskarström' },
  { lid: '4-9', lidl: 'Oxelösund' },
  { lid: '12-39', lidl: 'Oxie' },
  { lid: '25-13', lidl: 'Pajala' },
  { lid: '14-54', lidl: 'Partille' },
  { lid: '12-40', lidl: 'Perstorp' },
  { lid: '25-14', lidl: 'Piteå' },
  { lid: '18-15', lidl: 'Pålsboda' },
  { lid: '22-14', lidl: 'Ramsele' },
  { lid: '1-36', lidl: 'Rimbo' },
  { lid: '24-17', lidl: 'Robertsfors' },
  { lid: '9-4', lidl: 'Romakloster' },
  { lid: '10-9', lidl: 'Ronneby' },
  { lid: '7-9', lidl: 'Rottne' },
  { lid: '7-10', lidl: 'Ryd' },
  { lid: '6-16', lidl: 'Rydaholm' },
  { lid: '12-41', lidl: 'Rydebäck' },
  { lid: '20-16', lidl: 'Rättvik' },
  { lid: '25-15', lidl: 'Råneå' },
  { lid: '12-42', lidl: 'Råå' },
  { lid: '10-10', lidl: 'Rödeby' },
  { lid: '1-37', lidl: 'Rönninge' },
  { lid: '19-9', lidl: 'Sala' },
  { lid: '1-38', lidl: 'Saltsjö-boo' },
  { lid: '1-39', lidl: 'Saltsjöbaden' },
  { lid: '14-55', lidl: 'Sandared' },
  { lid: '21-21', lidl: 'Sandviken' },
  { lid: '1-40', lidl: 'Sigtuna' },
  { lid: '12-43', lidl: 'Simrishamn' },
  { lid: '12-44', lidl: 'Sjöbo' },
  { lid: '12-45', lidl: 'Skanör' },
  { lid: '14-56', lidl: 'Skara' },
  { lid: '1-41', lidl: 'Skarpnäck' },
  { lid: '24-18', lidl: 'Skellefteå' },
  { lid: '14-57', lidl: 'Skene' },
  { lid: '6-17', lidl: 'Skillingaryd' },
  { lid: '19-10', lidl: 'Skinnskatteberg' },
  { lid: '17-16', lidl: 'Skoghall' },
  { lid: '1-42', lidl: 'Skogås' },
  { lid: '19-11', lidl: 'Skultuna' },
  { lid: '12-46', lidl: 'Skurup' },
  { lid: '3-8', lidl: 'Skutskär' },
  { lid: '5-14', lidl: 'Skänninge' },
  { lid: '5-15', lidl: 'Skärblacka' },
  { lid: '14-58', lidl: 'Skärhamn' },
  { lid: '1-43', lidl: 'Skärholmen' },
  { lid: '1-44', lidl: 'Sköndal' },
  { lid: '14-59', lidl: 'Skövde' },
  { lid: '9-5', lidl: 'Slite' },
  { lid: '20-17', lidl: 'Smedjebacken' },
  { lid: '6-18', lidl: 'Smålandsstenar' },
  { lid: '14-60', lidl: 'Sollebrunn' },
  { lid: '22-15', lidl: 'Sollefteå' },
  { lid: '1-45', lidl: 'Sollentuna' },
  { lid: '1-46', lidl: 'Solna' },
  { lid: '24-19', lidl: 'Sorsele' },
  { lid: '1-47', lidl: 'Spånga' },
  { lid: '12-47', lidl: 'Staffanstorp' },
  { lid: '14-61', lidl: 'Stenungsund' },
  { lid: '14-62', lidl: 'Stora Höga' },
  { lid: '17-17', lidl: 'Storfors' },
  { lid: '23-16', lidl: 'Storlien' },
  { lid: '24-20', lidl: 'Storuman' },
  { lid: '21-22', lidl: 'Storvik' },
  { lid: '3-9', lidl: 'Storvreta' },
  { lid: '18-16', lidl: 'Storå' },
  { lid: '4-10', lidl: 'Strängnäs' },
  { lid: '7-11', lidl: 'Strömsnäsbruk' },
  { lid: '14-63', lidl: 'Strömstad' },
  { lid: '23-17', lidl: 'Strömsund' },
  { lid: '1-49', lidl: 'Sundbyberg' },
  { lid: '22-16', lidl: 'Sundsvall' },
  { lid: '20-18', lidl: 'Sunnansjö' },
  { lid: '17-18', lidl: 'Sunne' },
  { lid: '19-12', lidl: 'Surahammar' },
  { lid: '12-48', lidl: 'Svalöv' },
  { lid: '12-49', lidl: 'Svedala' },
  { lid: '23-18', lidl: 'Sveg' },
  { lid: '14-64', lidl: 'Svenljunga' },
  { lid: '23-19', lidl: 'Svenstavik' },
  { lid: '20-19', lidl: 'Svärdsjö' },
  { lid: '17-19', lidl: 'Säffle' },
  { lid: '20-20', lidl: 'Sälen' },
  { lid: '13-14', lidl: 'Särö' },
  { lid: '20-21', lidl: 'Säter' },
  { lid: '14-65', lidl: 'Sätila' },
  { lid: '24-21', lidl: 'Sävar' },
  { lid: '14-66', lidl: 'Sävedalen' },
  { lid: '6-19', lidl: 'Sävsjö' },
  { lid: '21-23', lidl: 'Söderhamn' },
  { lid: '5-16', lidl: 'Söderköping' },
  { lid: '1-50', lidl: 'Södertälje' },
  { lid: '12-50', lidl: 'Södra Sandby' },
  { lid: '25-16', lidl: 'Södra Sunderbyn' },
  { lid: '10-11', lidl: 'Sölvesborg' },
  { lid: '12-51', lidl: 'Sösdala' },
  { lid: '14-67', lidl: 'Tanumshede' },
  { lid: '14-68', lidl: 'Tibro' },
  { lid: '14-69', lidl: 'Tidaholm' },
  { lid: '3-10', lidl: 'Tierp' },
  { lid: '22-17', lidl: 'Timrå' },
  { lid: '7-12', lidl: 'Tingsryd' },
  { lid: '12-52', lidl: 'Tollarp' },
  { lid: '12-53', lidl: 'Tomelilla' },
  { lid: '17-20', lidl: 'Torsby' },
  { lid: '4-11', lidl: 'Torshälla' },
  { lid: '14-70', lidl: 'Torslanda' },
  { lid: '8-17', lidl: 'Torsås' },
  { lid: '13-15', lidl: 'Torup' },
  { lid: '14-71', lidl: 'Tranemo' },
  { lid: '6-20', lidl: 'Tranås' },
  { lid: '12-54', lidl: 'Trelleborg' },
  { lid: '14-72', lidl: 'Trollhättan' },
  { lid: '4-12', lidl: 'Trosa' },
  { lid: '1-51', lidl: 'Trångsund' },
  { lid: '1-52', lidl: 'Tullinge' },
  { lid: '1-53', lidl: 'Tumba' },
  { lid: '13-16', lidl: 'Tvååker' },
  { lid: '1-54', lidl: 'Tyresö' },
  { lid: '12-55', lidl: 'Tyringe' },
  { lid: '1-55', lidl: 'Täby' },
  { lid: '24-22', lidl: 'Tärnaby' },
  { lid: '17-21', lidl: 'Töcksfors' },
  { lid: '14-73', lidl: 'Töreboda' },
  { lid: '14-74', lidl: 'Uddevalla' },
  { lid: '13-17', lidl: 'Ullared' },
  { lid: '22-18', lidl: 'Ullånger' },
  { lid: '14-75', lidl: 'Ulricehamn' },
  { lid: '24-23', lidl: 'Umeå' },
  { lid: '1-56', lidl: 'Upplands Väsby' },
  { lid: '24-24', lidl: 'Ursviken' },
  { lid: '5-17', lidl: 'Vadstena' },
  { lid: '6-21', lidl: 'Vaggeryd' },
  { lid: '4-13', lidl: 'Vagnhärad' },
  { lid: '21-24', lidl: 'Valbo' },
  { lid: '5-18', lidl: 'Valdemarsvik' },
  { lid: '1-57', lidl: 'Vallentuna' },
  { lid: '20-22', lidl: 'Vansbro' },
  { lid: '14-76', lidl: 'Vara' },
  { lid: '13-18', lidl: 'Varberg' },
  { lid: '14-77', lidl: 'Vargön' },
  { lid: '1-58', lidl: 'Vaxholm' },
  { lid: '12-56', lidl: 'Veberöd' },
  { lid: '13-19', lidl: 'Veddige' },
  { lid: '12-57', lidl: 'Vellinge' },
  { lid: '6-22', lidl: 'Vetlanda' },
  { lid: '5-19', lidl: 'Vikbolandet' },
  { lid: '24-25', lidl: 'Vilhelmina' },
  { lid: '8-18', lidl: 'Vimmerby' },
  { lid: '24-26', lidl: 'Vindeln' },
  { lid: '4-14', lidl: 'Vingåker' },
  { lid: '12-58', lidl: 'Vinslöv' },
  { lid: '8-19', lidl: 'Virserum' },
  { lid: '9-6', lidl: 'Visby' },
  { lid: '14-78', lidl: 'Viskafors' },
  { lid: '7-13', lidl: 'Vislanda' },
  { lid: '25-17', lidl: 'Vittangi' },
  { lid: '6-23', lidl: 'Vrigstad' },
  { lid: '1-59', lidl: 'Väddö' },
  { lid: '1-60', lidl: 'Vällingby' },
  { lid: '14-79', lidl: 'Vänersborg' },
  { lid: '24-27', lidl: 'Vännäs' },
  { lid: '6-24', lidl: 'Värnamo' },
  { lid: '1-61', lidl: 'Västerhaninge' },
  { lid: '8-20', lidl: 'Västervik' },
  { lid: '14-80', lidl: 'Västra Frölunda' },
  { lid: '7-14', lidl: 'Växjö' },
  { lid: '17-22', lidl: 'Vålberg' },
  { lid: '1-62', lidl: 'Vårby' },
  { lid: '14-81', lidl: 'Vårgårda' },
  { lid: '5-20', lidl: 'Ydre' },
  { lid: '12-59', lidl: 'Ystad' },
  { lid: '14-82', lidl: 'Ytterby' },
  { lid: '7-15', lidl: 'Älmhult' },
  { lid: '1-63', lidl: 'Älta' },
  { lid: '20-23', lidl: 'Älvdalen' },
  { lid: '25-18', lidl: 'Älvsbyn' },
  { lid: '1-64', lidl: 'Älvsjö' },
  { lid: '14-83', lidl: 'Älvängen' },
  { lid: '12-60', lidl: 'Ängelholm' },
  { lid: '5-21', lidl: 'Åby' },
  { lid: '12-61', lidl: 'Åhus' },
  { lid: '1-65', lidl: 'Åkersberga' },
  { lid: '14-84', lidl: 'Åmål' },
  { lid: '22-19', lidl: 'Ånge' },
  { lid: '23-20', lidl: 'Åre' },
  { lid: '17-23', lidl: 'Årjäng' },
  { lid: '1-66', lidl: 'Årsta' },
  { lid: '13-20', lidl: 'Åsa' },
  { lid: '7-16', lidl: 'Åseda' },
  { lid: '24-28', lidl: 'Åsele' },
  { lid: '12-62', lidl: 'Åstorp' },
  { lid: '5-22', lidl: 'Åtvidaberg' },
  { lid: '14-85', lidl: 'Öckerö' },
  { lid: '5-23', lidl: 'Ödeshög' },
  { lid: '12-63', lidl: 'Ödåkra' },
  { lid: '25-19', lidl: 'Öjebyn' },
  { lid: '3-12', lidl: 'Öregrund' },
  { lid: '12-64', lidl: 'Örkelljunga' },
  { lid: '22-20', lidl: 'Örnsköldsvik' },
  { lid: '1-67', lidl: 'Ösmo' },
  { lid: '3-13', lidl: 'Österbybruk' },
  { lid: '23-21', lidl: 'Östersund' },
  { lid: '3-14', lidl: 'Östervåla' },
  { lid: '3-15', lidl: 'Östhammar' },
  { lid: '25-20', lidl: 'Överkalix' },
  { lid: '25-21', lidl: 'Övertorneå' },
];